const Login = () => import('./Login')
const Callback = () => import('./Callback')
const Verified = () => import('./Verified')
import Layout from '../../layouts/AuthLayout'

export default [
    {
        path: '/oauth',
        component: Layout,
        children: [
            { path: '', component: Callback, name: 'auth.oauth' },

        ]
    },
    {
        path: '/login',
        component: Layout,
        children: [
            { path: '', component: Login, name: 'auth.login' },
        ]
    },
    {
        path: '/verified',
        component: Layout,
        children: [
            { path: '', component: Verified, name: 'auth.verified',  meta: { guestRoute: true } },
        ],
    },
];
